// App.js
import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Home from './pages/Home';
import About from './pages/About';
import Works from './pages/Works';
import WorkDetail from './pages/WorkDetail';
import Articles from './pages/Articles';
import ArticleDetail from './pages/ArticleDetail';
import LandingBroadcast from './pages/LandingBroadcast';
import LandingDev from './pages/LandingDev';
import LandingTrainer from './pages/LandingTrainer';
import CustomCursor from './components/CustomCursor';
import SmoothScrollWrapper from './components/SmoothScrollWrapper';
import { WorksProvider } from './context/workConfig';
import { CodeProjectsProvider } from './context/codeConfig';
import { ArticlesProvider } from './context/articlesConfig';
import { TransitionProvider } from './context/TransitionContext';
import { LoadingProvider } from './context/LoadingContext';
import { WorkInProgressProvider } from './context/WorkInProgressContext';
import { LiveEditProvider } from './context/LiveEditContext';
import { CursorProvider } from './context/CursorContext';
import { LanguageProvider } from './context/LanguageContext';
import WorkInProgressGate from './components/WorkInProgressGate';
import TranslationOverlay from './components/TranslationOverlay';

const Code = lazy(() => import('./pages/Code'));
const CodeDetail = lazy(() => import('./pages/CodeDetail'));
const Playground = lazy(() => import('./pages/Playground'));
const Lab = lazy(() => import('./pages/Lab'));
const LandingGeneral = lazy(() => import('./pages/LandingGeneral'));

const App = () => {
  return (
    <HelmetProvider>
    <Router>
      <LanguageProvider>
        <WorkInProgressProvider>
        <WorkInProgressGate>
          <LoadingProvider>
            <WorksProvider>
              <CodeProjectsProvider>
                <ArticlesProvider>
                <LiveEditProvider>
                  <TransitionProvider>
                    <CursorProvider>
                      <div className="App">
                        <CustomCursor />
                        <TranslationOverlay />
                        <SmoothScrollWrapper>
                          <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/about" element={<About />} />
                            <Route path="/works" element={<Works />} />
                            <Route path="/work/:id" element={<WorkDetail />} />
                            <Route path="/articles" element={<Articles />} />
                            <Route path="/articles/:id" element={<ArticleDetail />} />
                            <Route path="/code" element={<Suspense fallback={null}><Code /></Suspense>} />
                            <Route path="/code/:id" element={<Suspense fallback={null}><CodeDetail /></Suspense>} />
                            <Route path="/playground" element={<Suspense fallback={null}><Playground /></Suspense>} />
                            <Route path="/landing-broadcast" element={<LandingBroadcast />} />
                            <Route path="/landing-dev" element={<LandingDev />} />
                            <Route path="/landing-trainer" element={<LandingTrainer />} />
                            <Route path="/landing-general" element={<Suspense fallback={null}><LandingGeneral /></Suspense>} />
                            <Route path="/lab" element={<Suspense fallback={null}><Lab /></Suspense>} />
                          </Routes>
                        </SmoothScrollWrapper>
                      </div>
                    </CursorProvider>
                  </TransitionProvider>
                </LiveEditProvider>
                </ArticlesProvider>
              </CodeProjectsProvider>
            </WorksProvider>
          </LoadingProvider>
        </WorkInProgressGate>
      </WorkInProgressProvider>
      </LanguageProvider>
    </Router>
    </HelmetProvider>
  );
};

export default App;